// frontend/src/pages/FilterPage.jsx
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, FormControl, InputLabel, Select, MenuItem,
  TextField, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions
 } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import LoginModal from '../components/LoginModal';

export default function FilterPage() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));


  const [selectedCultivo, setSelectedCultivo] = useState('');
  const [alimentosList, setAlimentosList] = useState([]);
  
  const [tipoAlimentos, setTipoAlimentos] = useState([]); 
  const [tipoResiduos, setTipoResiduos] = useState([]);
  const [selectedTipoAlimento, setSelectedTipoAlimento] = useState('');
  const [selectedTipoResiduo, setSelectedTipoResiduo] = useState('');
  const [selectedContaminante, setSelectedContaminante] = useState('');


  // Cargar tipos de alimento al inicio
  useEffect(() => {
    async function fetchTipoAlimentos() {
      try {
        const response = await api.get('/filtros/tipoalimentos');
        if (Array.isArray(response.data)) {
          setTipoAlimentos(response.data);
        } else {
          setTipoAlimentos([]);
        }
      } catch (error) {
        console.error('Error al obtener tipoalimentos:', error);
        setTipoAlimentos([]);
      }
    }
    fetchTipoAlimentos();
  }, []);

  // Al cambiar el tipo de alimento, cargar los alimentos
  useEffect(() => {
    async function fetchAlimentos() {
      if (selectedTipoAlimento) {
        try {
          const response = await api.get(`/filtros/alimentos?tipoalimento=${encodeURIComponent(selectedTipoAlimento)}`);
          if (Array.isArray(response.data)) {
            setAlimentosList(response.data);
          } else {
            setAlimentosList([]);
          }
          // Al cambiar el tipo de alimento, limpiamos selección de cultivo y residuos
          setSelectedCultivo('');
          setTipoResiduos([]);
          setSelectedTipoResiduo('');
          setSelectedContaminante('');
        } catch (error) {
          console.error('Error al obtener alimentos:', error);
          setAlimentosList([]);
          setSelectedCultivo('');
          setTipoResiduos([]);
          setSelectedTipoResiduo('');
        }
      } else {
        // Sin tipoAlimento, no hay alimentos
        setAlimentosList([]);
        setSelectedCultivo('');
        setTipoResiduos([]);
        setSelectedTipoResiduo('');
      }
    }

    fetchAlimentos();
  }, [selectedTipoAlimento]);

  // Al cambiar el cultivo, cargar los tipos de residuo
  useEffect(() => {
    async function fetchTipoResiduosFunction() {
      setSelectedTipoResiduo('');
      setTipoResiduos([]);
  
      if (!selectedTipoAlimento || !selectedCultivo || !selectedContaminante) return;
  
      if (selectedContaminante === 'CONTAMINANTE MICROBIOLÓGICO') {
        // Opciones fijas para microbiológico
        setTipoResiduos(['PATÓGENO', 'NO PATÓGENO']);
        return;
      }
  
      // CONTAMINANTE QUÍMICO → cargar desde backend
      try {
        const response = await api.get(
          `/filtros/tiporesiduos?tipoalimento=${encodeURIComponent(selectedTipoAlimento)}&cultivo=${encodeURIComponent(selectedCultivo)}`
        );
        setTipoResiduos(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error al obtener tiporesiduos:', error);
        setTipoResiduos([]);
      }
    }
    fetchTipoResiduosFunction();
  }, [selectedTipoAlimento, selectedCultivo, selectedContaminante]);

  function handleSearch() {
    if (!selectedTipoAlimento || !selectedCultivo || !selectedContaminante || !selectedTipoResiduo) {
      alert('Por favor seleccione tipo de alimento, alimento, contaminante y tipo de residuo');
      return;
    }

    const url = `/consulta?cultivo=${encodeURIComponent(selectedCultivo)}&tipoalimento=${encodeURIComponent(selectedTipoAlimento)}&tiporesiduo=${encodeURIComponent(selectedTipoResiduo)}`;
    navigate(url);
  }

  return (
    <>
    {!isLoggedIn && <LoginModal onLoginSuccess={() => setIsLoggedIn(true)} />}

    <Box 
      sx={{ 
        width: '100vw', 
        height: '100vh', 
        backgroundImage: 'url("/images/fondo.jpg")',
        backgroundSize: 'cover', 
        backgroundPosition: 'center',
        display: 'flex', 
        flexDirection: 'column'
      }}
    >
      <Box 
        sx={{ 
            width: '100%',
            height: '100vh', // Asegura que ocupa toda la altura del viewport
            backgroundImage: 'url(/images/plaguicidas.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            flex: 1,
            backdropFilter: 'blur(5px)', 
           
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: 'white',
            textShadow: '2px 2px 5px rgba(0, 0, 0, 0.8)',
            fontWeight: 'bold',
          }}
        >
          Límites Máximos Permisibles – SENASA
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: 'white',
            textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8)',
            marginBottom: 2,
          }}
        >
          Brinda información sobre los residuos químicos y otros contaminantes en alimentos agropecuarios primarios y piensos
        </Typography>

        <Box sx={{ display: 'flex', 
         flexDirection: { xs: 'column', sm: 'row' }, // Apilar en móvil, fila en pantallas más grandes
         gap: 1, // Espacio reducido entre elementos
            gap: 2, mt: 4, alignItems: 'center' }}>
          {/* Tipo de alimento */}
          <FormControl variant="filled" sx={{ minWidth: {xs: '80%', sm: 200 }, // 100% ancho en móvil
               maxWidth: 300,
            bgcolor: 'white', borderRadius: 1 }}>
            <InputLabel>Tipo de alimento</InputLabel>
            <Select
              value={selectedTipoAlimento}
              onChange={(e) => {
                setSelectedTipoAlimento(e.target.value);
              }}
            >
              {tipoAlimentos.map((tipo) => (
                <MenuItem key={tipo} value={tipo}>
                  {tipo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Alimento */}
          <FormControl variant="filled" sx={{ minWidth: {xs: '80%', sm: 200 }, // 100% ancho en móvil 
               maxWidth: 300,
            bgcolor: 'white', borderRadius: 1 }}>
            <InputLabel>Alimento</InputLabel>
            <Select
              value={selectedCultivo}
              onChange={(e) => setSelectedCultivo(e.target.value)}
              disabled={!selectedTipoAlimento || alimentosList.length === 0}

              // Puedes descomentar si el backend ya funciona: disabled={!selectedTipoAlimento || alimentosList.length === 0}
            >
              {alimentosList.map((al) => (
                <MenuItem key={al} value={al}>
                  {al}
                </MenuItem>
              ))}
            </Select>
          </FormControl>


{/* Contaminante */}
<FormControl variant="filled" sx={{ minWidth: { xs: '80%', sm: 200 }, maxWidth: 300, bgcolor: 'white', borderRadius: 1 }}>
  <InputLabel>Contaminante</InputLabel>
  <Select
    value={selectedContaminante}
    onChange={(e) => {
      setSelectedContaminante(e.target.value);
      setSelectedTipoResiduo('');
      setTipoResiduos([]);
    }}
    disabled={!selectedCultivo}
  >
    <MenuItem value="CONTAMINANTE QUÍMICO">CONTAMINANTE QUÍMICO</MenuItem>
    <MenuItem value="CONTAMINANTE MICROBIOLÓGICO">CONTAMINANTE MICROBIOLÓGICO</MenuItem>
  </Select>
</FormControl>





          {/* Tipo de residuo */}
          <FormControl variant="filled" sx={{ minWidth: { xs: '80%', sm: 200 }, // 100% ancho en móvil
             maxWidth: 500,
             bgcolor: 'white', borderRadius: 1 }}>
            <InputLabel>Residuos/Criterios Microbiológicos</InputLabel>
            <Select
              value={selectedTipoResiduo}
              onChange={(e) => {
                setSelectedTipoResiduo(e.target.value);
              }}
              disabled={!selectedContaminante || tipoResiduos.length === 0}

              // Puedes descomentar si el backend ya funciona: disabled={!selectedCultivo || tipoResiduos.length === 0}
            >
              {tipoResiduos.map((residuo) => (
                <MenuItem key={residuo} value={residuo}>
                  {residuo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button 
            variant="contained" 
            color="error" 
            onClick={handleSearch}
            sx={{width: { xs: '80%', sm: 'auto' },
            maxWidth: 300,
                 height: '56px',      
                  alignSelf: { xs: 'center', sm: 'start' },
                 }}
          >
            Ver Resultados
          </Button>



        </Box>
      

      </Box>
    </Box>
    </>
  );
}

